<template>
  <div class="main_body contact_page">
    <section id="hero_section">
      <div class="container">
        <navbar></navbar>
        <div class="main_logo">
          <img src="@/assets/images/Logo-011.png" alt="Logo-011.png">
        </div>
        <section class="contact_section">
          <div class="heading_section">
            <h3>Contact us</h3>
            <h5>
              All questions related to Good Morning Nanashi can be submitted down below.
              <br>
              <span>Please Note - Questions will be answered in the order received.</span>
            </h5>
          </div>
          <div class="row">
            <div class="form_wrapper">
              <form @submit.prevent="submitContactQuery">
                <div class="form-group">
                  <div class="row">
                    <div class="col-md-3 pt-3">
                      <label class="text-white font-weight-bold" for="name">Name</label>
                    </div>
                    <div class="col-md-9">
                      <input type="text" class="form-control" required id="name" v-model="contact.name"
                        placeholder="Your Name" name="name">
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="row">
                    <div class="col-md-3 pt-3">
                      <label class="text-white font-weight-bold" for="email">Email</label>
                    </div>
                    <div class="col-md-9">
                      <input type="email" class="form-control" required id="email" v-model="contact.email"
                        placeholder="your Email" name="email">
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="row">
                    <div class="col-md-3 pt-3">
                      <label class="text-white font-weight-bold" for="comment">Comment</label>
                    </div>
                    <div class="col-md-9">
                      <textarea class="form-control" rows="4" required id="comment" v-model="contact.comment"
                        placeholder="Comment"></textarea>
                    </div>
                  </div>
                </div>
                <div class="form-group ">
                  <div class="row">
                    <div class="col-md-3 pt-3">
                    </div>
                    <div class="col-md-9">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" value="agree" required v-model="contact.agree_to_terms"
                          class="custom-control-input" id="customCheck" name="example1">
                        <label class="custom-control-label" for="customCheck">I've read & accept the
                          <a href="javascript:void(0)" data-toggle="modal" data-target="#termsAndConditions">Terms &
                            Conditions</a></label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-3 pt-3">
                  </div>
                  <div class="col-md-9">
                    <captcha :captcha="captcha"></captcha>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-3 pt-3">
                  </div>
                  <div class="col-md-9">
                    <button type="submit" :disabled="this.$store.getters.apiStatus === 'loading'"
                      class="btn btn_submit">
                      <div v-if="this.$store.getters.apiStatus !== 'loading'">Submit Message</div>
                      <div v-else class="loader">
                        <Loader></Loader>
                      </div>
                    </button>
                  </div>
                </div>

              </form>
            </div>

          </div>
        </section>

        <social-links />
      </div>
    </section>
    <div class="modal fade" id="termsAndConditions">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">

          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title">Terms & Conditions</h4>
            <button type="button" class="close" data-dismiss="modal">&times;</button>
          </div>

          <!-- Modal body -->
          <div class="modal-body">
            Don't Spam Us - All e-Mails will be answered in the order they were received.<br>
            Patience - Is required, we get a huge volume of e-Mails.<br>
            Check Junk Mail - Before sending us another e-Mail.
          </div>

          <!-- Modal footer -->
          <div class="modal-footer">

            <button type="button" class="btn btn_submit" data-dismiss="modal">Close</button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import InstagramFeed from '../components/InstagramFeed.vue'
import Navbar from '../components/Navbar.vue'
import Captcha from '../components/Captcha.vue'
import SocialLinks from '../components/SocialLinks.vue'

export default {
  components: {
    Navbar,
    Captcha,
    SocialLinks
  },
  name: 'ContactUs',
  data () {
    return {
      captcha: {
        recaptchaVerified: false,
        value: null
      },
      contact: {
        name: '',
        email: '',
        comment: '',
        agree_to_terms: ''
      }
    }
  },
  methods: {
    submitContactQuery () {
      if (!this.contact.agree_to_terms) {
        this.$toast.error('Please agree to terms.')
        return
      }
      if (!this.captcha.recaptchaVerified) {
        this.$toast.error('Please verify captcha!')
        return
      }
      this.contact['g-recaptcha-response'] = this.captcha.value
      this.$store
        .dispatch('submitContactQuery', this.contact)
        .then(() => {
          this.$router.push('/')
          this.$toast.success('Your query has been submitted.')
        })
        .catch((err) => this.$helper.catchHandler(err))
    }
  }
}

</script>

<style scoped>
  .btn_submit {
    min-width: 189px;
    min-height: 50px;
  }

  .btn_submit:disabled {
    opacity: 1;
  }

</style>



// WEBPACK FOOTER //
// src/views/ContactUs.vue